/**
 * Developer utility for testing consent manager
 * Available in browser console as window.consentDebugger
 */

import { consentManager } from './consentManager';

export const consentDebugger = {
  /**
   * Check if user is from California
   */
  async isCaliforniaUser(): Promise<boolean> {
    const result = await consentManager.isCaliforniaUser();
    console.log('🌎 California User:', result);
    return result;
  },

  /**
   * Check if user has interacted
   */
  hasInteracted(): boolean {
    const result = consentManager.hasInteracted();
    console.log('👆 User Interacted:', result);
    return result;
  },



  /**
   * Show current state
   */
  async showState(): Promise<void> {
    console.group('🔍 Consent Manager State');
    console.log('California User:', await consentManager.isCaliforniaUser());
    console.log('Has Interacted:', consentManager.hasInteracted());
    console.log('Should Load GTM:', await consentManager.shouldLoadGTM());
    
    const regionData = localStorage.getItem('user_region');
    let parsedRegion = null;
    if (regionData) {
      try {
        const data = JSON.parse(regionData);
        const age = Date.now() - data.timestamp;
        const ageMinutes = Math.floor(age / 60000);
        const expiresInMinutes = Math.max(0, 30 - ageMinutes);
        parsedRegion = {
          region: data.region,
          cachedMinutesAgo: ageMinutes,
          expiresInMinutes: expiresInMinutes,
          expired: age >= 30 * 60 * 1000
        };
      } catch (e) {
        parsedRegion = 'Invalid format (old cache)';
      }
    }
    
    console.log('Local Storage:', {
      interaction: localStorage.getItem('user_interaction_ca'),
      regionCache: parsedRegion
    });
    console.groupEnd();
  },



  /**
   * Show help
   */
  help(): void {
    console.log(`
🛠️ Consent Debugger Commands:

  consentDebugger.showState()              - Show current consent state
  consentDebugger.isCaliforniaUser()       - Check if user is from California
  consentDebugger.shouldLoadGTM()          - Check if GTM should load
  consentDebugger.clearConsent()           - Clear all consent data
  consentDebugger.help()                   - Show this help

💡 Testing Tips:
  1. Clear consent and reload to test fresh state
  3. Check browser console for debug messages (if debug mode enabled)
  4. Watch Network tab for GTM requests
    `);
  }
};

// Expose to window in development
if (typeof window !== 'undefined') {
  (window as any).consentDebugger = consentDebugger;
}

